import React, { FC } from 'react'

import { IEventStatisticScoreInfoProps } from './EventStatisticScoreInfo.types'

export const EventStatisticScoreInfo: FC<IEventStatisticScoreInfoProps> = ({
  value
}) => <>{value}</>
